import React from 'react';

import AdminUpgradePlanContainer from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';
import AdminUpgradePlanStripeContainer from 'admin/components/AdminUpgradePlan/AdminUpgradePlanStripeContainer';

type Props = {
  orgUuid?: string;
};

export default function AdminUpgradePlanView(props: Props) {
  const { orgUuid } = props;

  return (
    <AdminUpgradePlanStripeContainer>
      <AdminUpgradePlanContainer orgUuid={orgUuid} />
    </AdminUpgradePlanStripeContainer>
  );
}
